module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Dietwil-19879724a66480f22b0cd5c6c9f4570b.svg";